export function formatAddressEllipsis(string: string) {
  if (!string) {
    return ''
  }
  const startSubstr = string.substr(0, 8)
  const endSubstr = string.substr(-6, 6)
  return startSubstr + ' ... ' + endSubstr
}

export const formatAddressEllipsisShort = (string: string) => {
  if (!string) {
    return ''
  }
  const startSubstr = string.substr(0, 4)
  const endSubstr = string.substr(-4, 4)
  return startSubstr + ' ... ' + endSubstr
}
